/**
 * Created by chenzheyu on 2017/6/9.
 */
import XkTextarea from './src/textarea.vue'

XkTextarea.install = function (Vue) {
  Vue.component(XkTextarea.name, XkTextarea)
}

export default XkTextarea



// WEBPACK FOOTER //
// ./src/components/module/textarea/index.js